import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dataAddAchievementAsync, dataUpdateAchievementAsync, 
  dataDeleteAchievementAsync, dataLoadAchievementsAsync, dataLoadAchievementsFilterAsync } from '../utils/dataApi';
import Debug from '../utils/logger';

const debug = new Debug('achievementsSlice');
debug.enabled = true;
debug.enableActions({'': true});


export const addAchievementAsync = createAsyncThunk(
  'achievements/addAchievement',
  async (achievement, { dispatch, rejectWithValue }) => {
    try {
      const response = await dataAddAchievementAsync(achievement);

      dispatch(fetchAchievements());  // Dispatch fetchAchievements after adding achievement
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateAchievementAsync = createAsyncThunk(
  'achievements/updateAchievement',
  async (achievement, { dispatch, rejectWithValue }) => {
    try {
      if(achievement.coreId) {
        achievement.coreId = achievement.coreId.toLowerCase();
      }
      const response = await dataUpdateAchievementAsync(achievement);
      if(response.error) {
        debug.error('updateAchievementAsync', response.error);
        return rejectWithValue(response);
      }
      dispatch(setShallLoadAchievements(true));
      //dispatch(fetchAchievements());  // Dispatch fetchAchievements after updating achievement
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteAchievementAsync = createAsyncThunk(
  'achievements/deleteAchievement',
  async (id, { dispatch, rejectWithValue }) => {
    try {
      let response = await dataDeleteAchievementAsync(id);
      if(response.error) {
        debug.error('deleteAchievementsAsync', response.error);
        return rejectWithValue(response);
      }
      dispatch(setShallLoadAchievements(true));
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchAchievements = createAsyncThunk('achievements/fetchAchievements', async (coreId = null) => {
  const response = await dataLoadAchievementsAsync(coreId? coreId.toLowerCase() : null);
  return response;
});

export const fetchAchievementsListUsers = createAsyncThunk('achievements/fetchAchievementsListUsers', async (coreIds) => {
  let sendCoreIds = coreIds? coreIds.map((coreId) => coreId.toLowerCase()) : [];
  const response = await dataLoadAchievementsFilterAsync(sendCoreIds, [])
  let ret = response;
  return ret;
});

export const fetchAchievementsListTeams = createAsyncThunk('achievements/fetchAchievementsListTeams', async (coreIds) => {
  let sendCoreIds = coreIds? coreIds.map((coreId) => coreId.toLowerCase()) : [];
  const response = await dataLoadAchievementsFilterAsync([], sendCoreIds)
  let ret = response;
  return ret;
});

const initialState = {
  achievements: [],
  selectedAchievement: null,
  shallLoadAchievements: true,
  status: 'idle',
  error: null,
};

export const achievementsSlice = createSlice({
  name: 'achievements',
  initialState,
  reducers: {
    addAchievement: () => {
      //const { coreId, actionId, badgeId, date, comment } = action.payload;
      //const id = date.getTime();
      //state.achievements.push({ id, coreId, actionId, badgeId, date, comment });
    },
    updateAchievement: () => {
      //const { id, coreId, actionId, badgeId, date, comment } = action.payload;
      //const index = state.achievements.findIndex(ach => ach.id === id);
      //if (index !== -1) {
        //state.achievements[index] = { id, coreId, actionId, badgeId, date, comment };
      //}
    },
    selectAchievement: (state, action) => {
      state.selectedAchievement = action.payload;
    },
    clearSelectedAchievement: (state) => {
      state.selectedAchievement = null;
    },
    setShallLoadAchievements: (state, action) => {
      state.shallLoadAchievements = action.payload;
    },
    clearAchievements: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addAchievementAsync.fulfilled, (state, action) => {
        //state.achievements.push(action.payload.message);
        state.status = 'succeeded';
      })
      .addCase(updateAchievementAsync.fulfilled, (state, action) => {
        //const { id, coreId, actionId, badgeId, date, comment } = action.payload.message;
        //const index = state.achievements.findIndex(ach => ach.id === id);
        //if (index !== -1) {
          //state.achievements[index] = { id, coreId, actionId, badgeId, date, comment };
        //}
        state.status = 'succeeded';
      })
      .addCase(deleteAchievementAsync.fulfilled, (state, action) => {
        //state.achievements = state.achievements.filter((achievement) => achievement.id !== action.payload);
        state.status = 'succeeded';
      })
      .addCase(addAchievementAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateAchievementAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteAchievementAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(addAchievementAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(updateAchievementAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(deleteAchievementAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchAchievements.fulfilled, (state, action) => {
        if(action.payload.error) {
          state.status = 'failed';
          state.error = action.payload.error;
          debug.warn('fetchAchievements.fulfilled', action.payload.error);
          return;
        }
        state.achievements = action.payload;
        state.status = 'succeeded';
      })
      .addCase(fetchAchievements.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAchievements.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchAchievementsListUsers.fulfilled, (state, action) => {
        if(action.payload.error) {
          state.status = 'failed';
          state.error = action.payload.error;
          debug.warn('fetchAchievementsListUsers.fulfilled', action.payload.error);
          return;
        }
        state.achievements = action.payload;
        state.status = 'succeeded';
      })
      .addCase(fetchAchievementsListUsers.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAchievementsListUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchAchievementsListTeams.fulfilled, (state, action) => {
        if(action.payload.error) {
          state.status = 'failed';
          state.error = action.payload.error;
          debug.warn('fetchAchievementsListTeams.fulfilled', action.payload.error);
          return;
        }
        state.achievements = action.payload;
        state.status = 'succeeded';
      })
      .addCase(fetchAchievementsListTeams.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAchievementsListTeams.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { addAchievement, updateAchievement, selectAchievement, clearAchievements,
  clearSelectedAchievement, setShallLoadAchievements } = achievementsSlice.actions;

export default achievementsSlice.reducer;

